// Material
import { styled } from '@mui/material/styles'
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'

const StyledListItemButton = styled(ListItemButton)`
  height: 50px;
  text-align: inherit;
  box-sizing: border-box;
  padding: 8px 15px;
`

const StyledListItem = styled(ListItem)`
  text-align: inherit;
  padding: 0;
  .MuiTouchRipple-child {
    background-color: #f9f9f9;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 24px;
  margin-left: 15px;
`

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
    color: theme.palette.secondary.main,
  },
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  Icon: JSX.Element
  onClick: () => any
  children: JSX.Element | string
  disabled?: boolean
}

export function InviteActionItem({ Icon, onClick, children, disabled }: Props) {
  return (
    <>
      <StyledListItem onClick={onClick} disabled={disabled}>
        <StyledListItemButton disableGutters>
          <StyledListItemIcon>{Icon}</StyledListItemIcon>
          <StyledListItemText>{children}</StyledListItemText>
        </StyledListItemButton>
      </StyledListItem>

      <StyledDivider />
    </>
  )
}

InviteActionItem.defaultProps = {
  disabled: false,
}
